import SellerTableFilter from "./seller-table-filter";


const SellerFilters = {
    Table: SellerTableFilter,
}

export default SellerFilters;